import styled, { css } from 'styled-components';
import { TimeLineSegmentLine, TimeLineSegmentStatus } from './types';

export const Icon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const LineTop = styled.div`
  width: 2px;
  border-left: solid 2px ${({ theme }) => theme.colors.primary.cyan};
`;

export const LineBottom = styled.div`
  height: 100%;
  width: 2px;
  border-left: solid 2px ${({ theme }) => theme.colors.primary.cyan};
`;

export const Bullet = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 21px;
  min-height: 21px;
  border-radius: 50%;
`;

export const Container = styled.div<{
  $lineTop: TimeLineSegmentLine;
  $iconOffset: string;
  $status: TimeLineSegmentStatus;
  $lineBottom: TimeLineSegmentLine;
}>`
  display: flex;
  flex-direction: column;
  align-content: stretch;
  align-items: center;
  width: 40px;
  height: 100%;

  ${({ $iconOffset }) =>
    $iconOffset &&
    css`
      & ${LineTop} {
        min-height: ${$iconOffset};
      }
    `}

  ${({ $lineTop }) =>
    $lineTop === 'none' &&
    css`
      & ${LineTop} {
        border: none;
      }
    `}

  ${({ $lineTop }) =>
    $lineTop === 'pending' &&
    css`
      & ${LineTop} {
        border-left-style: dotted;
      }
    `}

  ${({ $lineTop }) =>
    $lineTop === 'active' &&
    css`
      & ${LineTop} {
        border-left-style: solid;
      }
    `}

  ${({ $lineBottom }) =>
    $lineBottom === 'none' &&
    css`
      & ${LineBottom} {
        border: none;
      }
    `}

  ${({ $lineBottom }) =>
    $lineBottom === 'pending' &&
    css`
      & ${LineBottom} {
        border-left-style: dotted;
      }
    `}

  ${({ $lineBottom }) =>
    $lineBottom === 'active' &&
    css`
      & ${LineBottom} {
        border-left-style: dotted;
      }
    `}

  ${({ theme, $status }) =>
    $status === 'pending' &&
    css`
      & ${Bullet} {
        border: solid 1px ${theme.colors.primary.cyan};
        background-color: ${theme.colors.primary.white};

        & ${Icon} > svg {
          fill: ${theme.colors.primary.cyan};
        }
      }
    `}

  ${({ theme, $status }) =>
    $status === 'past' &&
    css`
      & ${Bullet} {
        background-color: ${theme.colors.primary.cyan};

        & ${Icon} > svg {
          fill: ${theme.colors.primary.white};
        }
      }
    `}

  ${({ theme, $status }) =>
    $status === 'active' &&
    css`
      & ${Bullet} {
        background-color: ${theme.colors.secondary.green};

        & ${Icon} > svg {
          fill: ${theme.colors.primary.white};
        }
      }
    `}
`;
